// API bindings: roomusers (Auto generated)

"use strict";

import { RequestErrorHandler, RequestParams, CommonAuthenticatedErrorHandler } from "@asanrom/request-browser";
import { getApiUrl, generateURIQuery } from "./utils";
import { RoomUserList, RoomUserItem, UserRoleRequest } from "./definitions";

export class ApiRoomusers {
    /**
     * Method: GET
     * Path: /room/{roomId}/users
     * Get room users permissions
     * @param roomId Room ID
     * @param queryParams Query parameters
     * @param headerParams Header parameters
     * @returns The request parameters
     */
    public static GetRoomRoomidUsers(roomId: string, queryParams: GetRoomRoomidUsersQueryParameters, headerParams: GetRoomRoomidUsersHeaderParameters): RequestParams<RoomUserList, GetRoomRoomidUsersErrorHandler> {
        return {
            method: "GET",
            url: getApiUrl(`/room/${encodeURIComponent(roomId)}/users` + generateURIQuery(queryParams)),
            headers: headerParams as any,
            handleError: (err, handler) => {
                new RequestErrorHandler()
                    .add(404, "*", handler.notFound)
                    .add(403, "*", handler.forbidden)
                    .add(401, "*", handler.unauthorized)
                    .add(500, "*", "serverError" in handler ? handler.serverError : handler.temporalError)
                    .add("*", "*", "networkError" in handler ? handler.networkError : handler.temporalError)
                    .handle(err);
            },
        };
    }

    /**
     * Method: GET
     * Path: /room/{roomId}/user/{userId}
     * Get specific user permission
     * @param roomId Room ID
     * @param userId User ID
     * @param headerParams Header parameters
     * @returns The request parameters
     */
    public static GetRoomRoomidUserUserid(roomId: string, userId: string, headerParams: GetRoomRoomidUserUseridHeaderParameters): RequestParams<RoomUserItem, GetRoomRoomidUserUseridErrorHandler> {
        return {
            method: "GET",
            url: getApiUrl(`/room/${encodeURIComponent(roomId)}/user/${encodeURIComponent(userId)}`),
            headers: headerParams as any,
            handleError: (err, handler) => {
                new RequestErrorHandler()
                    .add(404, "*", handler.notFound)
                    .add(403, "*", handler.forbidden)
                    .add(400, "*", handler.badRequest)
                    .add(401, "*", handler.unauthorized)
                    .add(500, "*", "serverError" in handler ? handler.serverError : handler.temporalError)
                    .add("*", "*", "networkError" in handler ? handler.networkError : handler.temporalError)
                    .handle(err);
            },
        };
    }

    /**
     * Method: DELETE
     * Path: /room/{roomId}/user/{userId}
     * Removes user
     * @param roomId Room ID
     * @param userId User ID
     * @returns The request parameters
     */
    public static DeleteRoomRoomidUserUserid(roomId: string, userId: string): RequestParams<void, DeleteRoomRoomidUserUseridErrorHandler> {
        return {
            method: "DELETE",
            url: getApiUrl(`/room/${encodeURIComponent(roomId)}/user/${encodeURIComponent(userId)}`),
            handleError: (err, handler) => {
                new RequestErrorHandler()
                    .add(404, "*", handler.notFound)
                    .add(403, "*", handler.forbidden)
                    .add(401, "*", handler.unauthorized)
                    .add(500, "*", "serverError" in handler ? handler.serverError : handler.temporalError)
                    .add("*", "*", "networkError" in handler ? handler.networkError : handler.temporalError)
                    .handle(err);
            },
        };
    }

    /**
     * Method: POST
     * Path: /room/{roomId}/user/{userId}/role
     * Sets user role
     * @param roomId Room ID
     * @param userId User ID
     * @param body Body parameters
     * @returns The request parameters
     */
    public static PostRoomRoomidUserUseridRole(roomId: string, userId: string, body: UserRoleRequest): RequestParams<void, PostRoomRoomidUserUseridRoleErrorHandler> {
        return {
            method: "POST",
            url: getApiUrl(`/room/${encodeURIComponent(roomId)}/user/${encodeURIComponent(userId)}/role`),
            json: body,
            handleError: (err, handler) => {
                new RequestErrorHandler()
                    .add(404, "*", handler.notFound)
                    .add(403, "*", handler.forbidden)
                    .add(400, "*", handler.badRequest)
                    .add(401, "*", handler.unauthorized)
                    .add(500, "*", "serverError" in handler ? handler.serverError : handler.temporalError)
                    .add("*", "*", "networkError" in handler ? handler.networkError : handler.temporalError)
                    .handle(err);
            },
        };
    }

    /**
     * Method: POST
     * Path: /room/{roomId}/user/{userId}/ban
     * Bans user
     * @param roomId Room ID
     * @param userId User ID
     * @returns The request parameters
     */
    public static PostRoomRoomidUserUseridBan(roomId: string, userId: string): RequestParams<void, PostRoomRoomidUserUseridBanErrorHandler> {
        return {
            method: "POST",
            url: getApiUrl(`/room/${encodeURIComponent(roomId)}/user/${encodeURIComponent(userId)}/ban`),
            handleError: (err, handler) => {
                new RequestErrorHandler()
                    .add(404, "*", handler.notFound)
                    .add(403, "*", handler.forbidden)
                    .add(400, "*", handler.badRequest)
                    .add(401, "*", handler.unauthorized)
                    .add(500, "*", "serverError" in handler ? handler.serverError : handler.temporalError)
                    .add("*", "*", "networkError" in handler ? handler.networkError : handler.temporalError)
                    .handle(err);
            },
        };
    }

    /**
     * Method: POST
     * Path: /room/{roomId}/user/{userId}/unban
     * Unbans user
     * @param roomId Room ID
     * @param userId User ID
     * @returns The request parameters
     */
    public static PostRoomRoomidUserUseridUnban(roomId: string, userId: string): RequestParams<void, PostRoomRoomidUserUseridUnbanErrorHandler> {
        return {
            method: "POST",
            url: getApiUrl(`/room/${encodeURIComponent(roomId)}/user/${encodeURIComponent(userId)}/unban`),
            handleError: (err, handler) => {
                new RequestErrorHandler()
                    .add(404, "*", handler.notFound)
                    .add(403, "*", handler.forbidden)
                    .add(400, "*", handler.badRequest)
                    .add(401, "*", handler.unauthorized)
                    .add(500, "*", "serverError" in handler ? handler.serverError : handler.temporalError)
                    .add("*", "*", "networkError" in handler ? handler.networkError : handler.temporalError)
                    .handle(err);
            },
        };
    }

    /**
     * Method: POST
     * Path: /room/{roomId}/user/{userId}/accept
     * Accepts user
     * @param roomId Room ID
     * @param userId User ID
     * @returns The request parameters
     */
    public static PostRoomRoomidUserUseridAccept(roomId: string, userId: string): RequestParams<void, PostRoomRoomidUserUseridAcceptErrorHandler> {
        return {
            method: "POST",
            url: getApiUrl(`/room/${encodeURIComponent(roomId)}/user/${encodeURIComponent(userId)}/accept`),
            handleError: (err, handler) => {
                new RequestErrorHandler()
                    .add(404, "*", handler.notFound)
                    .add(403, "*", handler.forbidden)
                    .add(400, "*", handler.badRequest)
                    .add(401, "*", handler.unauthorized)
                    .add(500, "*", "serverError" in handler ? handler.serverError : handler.temporalError)
                    .add("*", "*", "networkError" in handler ? handler.networkError : handler.temporalError)
                    .handle(err);
            },
        };
    }

    /**
     * Method: DELETE
     * Path: /room/{roomId}/user/{userId}/reject
     * Reject a join request
     * @param roomId Room ID
     * @param userId User ID
     * @returns The request parameters
     */
    public static DeleteRoomRoomidUserUseridReject(roomId: string, userId: string): RequestParams<void, DeleteRoomRoomidUserUseridRejectErrorHandler> {
        return {
            method: "DELETE",
            url: getApiUrl(`/room/${encodeURIComponent(roomId)}/user/${encodeURIComponent(userId)}/reject`),
            handleError: (err, handler) => {
                new RequestErrorHandler()
                    .add(404, "*", handler.notFound)
                    .add(403, "*", handler.forbidden)
                    .add(400, "*", handler.badRequest)
                    .add(401, "*", handler.unauthorized)
                    .add(500, "*", "serverError" in handler ? handler.serverError : handler.temporalError)
                    .add("*", "*", "networkError" in handler ? handler.networkError : handler.temporalError)
                    .handle(err);
            },
        };
    }
}

/**
 * Error handler for GetRoomRoomidUsers
 */
export type GetRoomRoomidUsersErrorHandler = CommonAuthenticatedErrorHandler & {
    /**
     * General handler for status = 403
     */
    forbidden: () => void;

    /**
     * General handler for status = 404
     */
    notFound: () => void;
};

/**
 * Query parameters for GetRoomRoomidUsers
 */
export interface GetRoomRoomidUsersQueryParameters {
    /**
     * Page. Starting by 1.
     */
    page?: number;

    /**
     * Kind of user. Can be: 'all', 'banned', 'mod' or 'admin'
     */
    kind?: string;

    /**
     * Search for registered users, this overrides kind
     */
    q?: string;
}

/**
 * Header parameters for GetRoomRoomidUsers
 */
export interface GetRoomRoomidUsersHeaderParameters {
    /**
     * Version ID (when joining with code)
     */
    "x-room-version-id"?: string;

    /**
     * Version Code (when joining with code)
     */
    "x-room-version-code"?: string;
}

/**
 * Error handler for GetRoomRoomidUserUserid
 */
export type GetRoomRoomidUserUseridErrorHandler = CommonAuthenticatedErrorHandler & {
    /**
     * General handler for status = 400
     */
    badRequest: () => void;

    /**
     * General handler for status = 403
     */
    forbidden: () => void;

    /**
     * General handler for status = 404
     */
    notFound: () => void;
};

/**
 * Header parameters for GetRoomRoomidUserUserid
 */
export interface GetRoomRoomidUserUseridHeaderParameters {
    /**
     * Version ID (when joining with code)
     */
    "x-room-version-id"?: string;

    /**
     * Version Code (when joining with code)
     */
    "x-room-version-code"?: string;
}

/**
 * Error handler for DeleteRoomRoomidUserUserid
 */
export type DeleteRoomRoomidUserUseridErrorHandler = CommonAuthenticatedErrorHandler & {
    /**
     * General handler for status = 403
     */
    forbidden: () => void;

    /**
     * General handler for status = 404
     */
    notFound: () => void;
};

/**
 * Error handler for PostRoomRoomidUserUseridRole
 */
export type PostRoomRoomidUserUseridRoleErrorHandler = CommonAuthenticatedErrorHandler & {
    /**
     * General handler for status = 400
     */
    badRequest: () => void;

    /**
     * General handler for status = 403
     */
    forbidden: () => void;

    /**
     * General handler for status = 404
     */
    notFound: () => void;
};

/**
 * Error handler for PostRoomRoomidUserUseridBan
 */
export type PostRoomRoomidUserUseridBanErrorHandler = CommonAuthenticatedErrorHandler & {
    /**
     * General handler for status = 400
     */
    badRequest: () => void;

    /**
     * General handler for status = 403
     */
    forbidden: () => void;

    /**
     * General handler for status = 404
     */
    notFound: () => void;
};

/**
 * Error handler for PostRoomRoomidUserUseridUnban
 */
export type PostRoomRoomidUserUseridUnbanErrorHandler = CommonAuthenticatedErrorHandler & {
    /**
     * General handler for status = 400
     */
    badRequest: () => void;

    /**
     * General handler for status = 403
     */
    forbidden: () => void;

    /**
     * General handler for status = 404
     */
    notFound: () => void;
};

/**
 * Error handler for PostRoomRoomidUserUseridAccept
 */
export type PostRoomRoomidUserUseridAcceptErrorHandler = CommonAuthenticatedErrorHandler & {
    /**
     * General handler for status = 400
     */
    badRequest: () => void;

    /**
     * General handler for status = 403
     */
    forbidden: () => void;

    /**
     * General handler for status = 404
     */
    notFound: () => void;
};

/**
 * Error handler for DeleteRoomRoomidUserUseridReject
 */
export type DeleteRoomRoomidUserUseridRejectErrorHandler = CommonAuthenticatedErrorHandler & {
    /**
     * General handler for status = 400
     */
    badRequest: () => void;

    /**
     * General handler for status = 403
     */
    forbidden: () => void;

    /**
     * General handler for status = 404
     */
    notFound: () => void;
};

